import { GET, POST, PUT, DELETE } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import deprecationPlanEndpoints from '../api/deprecationPlanEndpoints'
import { DeprecationPlan, DeprecationPlanPayload } from '../types'

export const fetchDeprecationPlans = async (
  companyId: string,
  budgetingScenarioId?: number | null,
  dimensions?: string
): Promise<DeprecationPlan[]> => {
  const plans = await backendRequest<DeprecationPlan[]>({
    method: GET,
    url: deprecationPlanEndpoints.list(companyId),
    params: {
      budgetingScenarioId: budgetingScenarioId ?? null,
      dimensions
    }
  })

  // Transform value from string to number (backend returns DECIMAL as string)
  return plans.map(plan => {
    const parsedValue = Number(plan.value)
    if (!Number.isFinite(parsedValue)) {
      console.error(`Invalid deprecation plan value for plan ID ${plan.id}: ${plan.value}`)
      return {
        ...plan,
        value: 0 // Fallback to 0 for invalid values
      }
    }
    return {
      ...plan,
      value: parsedValue
    }
  })
}

export const createDeprecationPlan = async (companyId: string, data: DeprecationPlanPayload) => {
  const parsedValue = Number(data.value)
  if (!Number.isFinite(parsedValue)) {
    throw new Error(`Invalid deprecation plan value: ${data.value}`)
  }

  return backendRequest<DeprecationPlan>({
    method: POST,
    url: deprecationPlanEndpoints.create(companyId),
    data: {
      ...data,
      value: parsedValue
    }
  })
}

export const updateDeprecationPlan = async (companyId: string, id: number, data: DeprecationPlanPayload) => {
  const parsedValue = Number(data.value)
  if (!Number.isFinite(parsedValue)) {
    throw new Error(`Invalid deprecation plan value: ${data.value}`)
  }

  return backendRequest<DeprecationPlan>({
    method: PUT,
    url: deprecationPlanEndpoints.update(companyId, id),
    data: {
      ...data,
      value: parsedValue
    }
  })
}

export const deleteDeprecationPlan = async (companyId: string, id: number) => {
  return backendRequest<void>({
    method: DELETE,
    url: deprecationPlanEndpoints.delete(companyId, id)
  })
}
